<template>
  <div>
    <PaymentFormSingleCharge
      v-if="isLifetimePlanSelected"
      :item-selected="itemSelected"
      :is-onboarding="isOnboarding"
      :promo-code="promoCode"
      @loaded="$emit('loaded')"
      @payment-success="subscriptionSuccess"
    />
    <PaymentFormComponent
      v-else
      :item-selected="itemSelected"
      :is-onboarding="isOnboarding"
      :promo-code="promoCode"
      @loaded="$emit('loaded')"
      @payment-success="subscriptionSuccess"
    />
  </div>
</template>

<script>
import PaymentFormComponent from '@/components/payment/PaymentFormComponent';
import PaymentFormSingleCharge from '@/components/payment/PaymentFormSingleChargeComponent';
import { mapActions } from 'vuex';
export default {
  components: { PaymentFormComponent, PaymentFormSingleCharge },
  props: ['itemSelected', 'isOnboarding', 'promoCode'],
  computed: {
    isLifetimePlanSelected() {
      if (!this.itemSelected) {
        return false;
      }

      return this.itemSelected.title === 'Lifetime';
    },
  },
  mounted() {
    this.getUserPaymentMethod();
  },
  methods: {
    ...mapActions('profile', ['getUserPaymentMethod']),
    subscriptionSuccess(payload) {
      this.$emit('payment-success', payload);
    },
  },
};
</script>
